import {
  fetchCompanyGameStatsMobileTrend,
  fetchCompanyStatsMobileGamesShareTable,
  fetchCompanyStatsMobileGamesShareTrend,
  fetchCompanyStatsMobileCountryShareTable,
  fetchCompanyStatsMobileCountryShareTrend,
} from '@/pages/intelligence/services/companies';
import { getComputeTypeStreaming } from '@/pages/intelligence/utils/topchartsUtils';
import { valueFormat, growthFormat } from '@/pages/intelligence/utils/commonUtils';

export function findRevenueData(lineData: any[], metric: string, dataSource = 'appannie') {
  const foundDataSource = lineData?.find((item: any) => item?.data_source === dataSource);
  const foundList =
    foundDataSource?.metrics || foundDataSource?.metrics_list || foundDataSource?.metric;
  const foundMetric = foundList?.find((item: any) => item?.metric === metric);

  return foundMetric || null;
}

export async function getRevenueDownladTrendData(params, tabId) {
  // 加载数据，例如从 API
  // 使用 applyFilter 筛选数据
  // 渲染卡片
  try {
    const trendsRes = await fetchCompanyGameStatsMobileTrend({
      ...params,
      order_metric: 'date',
    });
    // 1 折线图数据有点冗余，可以在这处理一下
    // 2 聚合数据单独拿出来
    // 3 后端返回的时间也取出来
    const lineData = trendsRes?.data?.metric_time_line || [];
    const foundDataSource = lineData[0];

    const foundMetric = foundDataSource?.metrics?.find((item: any) => item?.metric === tabId);

    const trendCoundMsg = getComputeTypeStreaming(
      foundMetric?.avg_by_line,
      foundMetric?.total_by_line,
      foundMetric?.max_by_line,
    );

    const tableData = trendsRes?.data?.data_list || [];
    const trendTotal = tableData?.length;

    return {
      cardStats: {
        isLoading: false,
        isError: false,
        isNoData: !trendTotal,
      },
      lineData: foundMetric?.history || [],
      tableData,
      total: trendTotal,
      startDate: trendsRes?.data?.start_data_time || '',
      endDate: trendsRes?.data?.end_data_time || '',
      trendCoundMsg,
    };
  } catch (err) {
    console.error(err);
    return {
      cardStats: {
        isLoading: false,
        isError: true,
        isNoData: true,
      },
      lineData: [],
      tableData: [],
      total: 0,
      startDate: '',
      endDate: '',
      trendCoundMsg: {},
    };
  }
}

export async function getRevenueDownloadGamesData(params, tabId, data_source) {
  // 加载数据，例如从 API
  // 使用 applyFilter 筛选数据
  // 渲染卡片
  try {
    const gamesRes = await fetchCompanyStatsMobileGamesShareTable(params);
    // 1 aggregated为可视化柱状和饼， 需要过滤掉allgame
    // 2 表格数据排序和分页需要重新调接口，但可视化不需要更新
    // 3 请求折线图接口，需要给top5游戏数据，页面改变筛选器才重新请求

    const topIds = gamesRes?.data?.aggregated
      .filter((item) => item?.id !== 'All Games' && item?.id !== 'Others')
      .map((item) => item?.id);
    const barOrPieData = gamesRes?.data?.aggregated.filter((item) => item?.id !== 'All Games');
    const tableData = gamesRes?.data?.game_data || [];
    const gameTotal = gamesRes?.data?.total_games_data || 0;
    const gamesLineRes = await fetchCompanyStatsMobileGamesShareTrend({
      ...params,
      ids: topIds,
    });
    const lineData = gamesLineRes?.data?.metric_time_line || [];
    const foundMetric = findRevenueData(lineData, tabId, data_source);
    return {
      cardStats: {
        isLoading: false,
        isError: false,
        isNoData: !gameTotal,
      },
      lineData: foundMetric?.games || [],
      tableData,
      barOrPieData: tableData, // barOrPieData，
      total: gameTotal,
    };
  } catch (err) {
    return {
      cardStats: {
        isLoading: false,
        isError: true,
        isNoData: true,
      },
      lineData: [],
      tableData: [],
      barOrPieData: [],
      total: 0,
    };
  }
}

export async function getRevenueDownloadGamesTable(params, tabId) {
  try {
    const gamesRes = await fetchCompanyStatsMobileGamesShareTable(params);
    const tableData = gamesRes?.data?.game_data || [];
    const allGamesObject = tableData?.find((item) => item.id === 'All Games');
    const newTableList = tableData.filter((item) => item.id !== 'All Games');
    if (allGamesObject) {
      newTableList.unshift(allGamesObject);
    }
    const gameTotal = gamesRes?.data?.total_games_data || 0;
    return newTableList;
  } catch (err) {
    return [];
  }
}

export async function getRevenueDownloadCountryData(params, tabId, data_source) {
  // 加载数据，例如从 API
  // 使用 applyFilter 筛选数据
  // 渲染卡片
  try {
    const countryRes = await fetchCompanyStatsMobileCountryShareTable(params);
    // 1 aggregated为可视化柱状和饼， 需要过滤掉allgame
    // 2 表格数据排序和分页需要重新调接口，但可视化不需要更新
    // 3 请求折线图接口，需要给top5游戏数据，页面改变筛选器才重新请求

    const topIds = countryRes?.data?.aggregated
      .filter((item) => item?.region !== 'Others')
      .map((item) => item?.region);
    const tableData = countryRes?.data?.game_market_data || [];
    const gameTotal = countryRes?.data?.total_games_data || 0;
    const countryLineRes = await fetchCompanyStatsMobileCountryShareTrend({
      ...params,
      ids: topIds,
    });
    const lineData = countryLineRes?.data?.metric_time_line || [];
    const foundMetric = findRevenueData(lineData, tabId, data_source);
    const newTableList = tableData?.map((t) => {
      return {
        market: t?.region,
        ...(t || {}),
      };
    });
    const barOrPieData = countryRes?.data?.aggregated || [];

    return {
      cardStats: {
        isLoading: false,
        isError: false,
        isNoData: !gameTotal,
      },
      lineData: foundMetric?.games
        ? foundMetric?.games
        : foundMetric?.market_data
        ? foundMetric?.market_data
        : [],
      tableData: newTableList,
      barOrPieData: newTableList, // barOrPieData，
      total: gameTotal,
    };
  } catch (err) {
    return {
      cardStats: {
        isLoading: false,
        isError: true,
        isNoData: true,
      },
      lineData: [],
      tableData: [],
      barOrPieData: [],
      total: 0,
    };
  }
}

export async function getRevenueDownloadCountryTable(params, tabId) {
  try {
    const countryRes = await fetchCompanyStatsMobileCountryShareTable(params);
    const tableData = countryRes?.data?.game_market_data || [];
    const gameTotal = countryRes?.data?.total_games_data || 0;
    const newTableList = tableData?.map((t) => {
      return {
        market: t?.region,
        ...(t || {}),
      };
    });
    return newTableList;
  } catch (err) {
    return [];
  }
}

export const getCompanyRevenueDownloadValueOfCvm = (metric: any) => {
  const value = valueFormat(metric?.value);
  if (metric?.metric?.indexOf('_company') > -1) {
    return {
      value: metric?.value2,
    };
  }
  const growthDataObj = growthFormat({
    value: metric?.dod_int || metric?.dod_Int,
    valueType: 'percentValue',
    hasPoint: 'lessThanOne',
    fixedNum: 2,
    maxNumber: 99999,
  });
  return { value, growthDataObj };
};
